import { defineModule } from '@kubdee/sdk'
import { MODULES } from '@kubdee/shared'
import { migrations } from './migrations'
import { marketingDoctypes } from './doctypes'

// Run pnpm gen:modules after changing icons so the generated icon registry stays in sync.
const MODULE_ICON = 'Megaphone'
const MODULE_COLOR = '#2490EF'

// ============================================================================
// Scheduler handler registration for `social-posting.publish` (#790) lives in
// `./services/scheduler-bootstrap.ts` and is imported as a side-effect from
// `apps/api/src/index.ts`. It is intentionally NOT imported here because this
// file is walked by `apps/web`'s typecheck (via `ui/layout.tsx`'s bare
// `import marketingModule from "@kubdee/module-marketing"`), and the
// bootstrap file pulls in the connectors backend chain (Durable Object,
// CF globals) which apps/web's tsconfig cannot resolve.
// ============================================================================

export default defineModule({
  name: MODULES.MARKETING,
  label: 'การตลาด',
  displayName: 'Marketing',
  icon: MODULE_ICON,
  color: MODULE_COLOR,
  version: '0.1.0',
  // Depends on connectors for OAuth, token vault, scheduler, and provider
  // adapters. Marketing must not store provider tokens or call Graph/HTTP
  // APIs directly — every outbound publish goes through
  // `connectors.call(instanceId, 'social-posting', method, args)`.
  dependencies: [MODULES.CORE, MODULES.CONNECTORS],
  category: 'operations',
  isSystemModule: false,

  schemas: {},
  routes: {},
  navigation: {
    label: 'การตลาด',
    icon: MODULE_ICON,
    groups: [
      {
        label: 'จัดการ',
        items: [
          { label: 'โพสต์', path: '/marketing/posts', icon: 'FileText' },
        ],
      },
      {
        label: 'ตั้งค่า',
        items: [
          { label: 'ตั้งค่าทั่วไป', path: '/marketing/settings', icon: 'Settings' },
        ],
      },
    ],
  },
  permissions: {},
  hooks: {},

  // Lightweight doctype registry (permission matrix + workflow builder).
  // Full `registeredDoctypes` below carries the metadata-rich definitions
  // consumed by the Doctype Admin catalog (#786).
  doctypes: [
    { key: 'campaigns', label: 'แคมเปญ' },
    { key: 'content-posts', label: 'โพสต์คอนเทนต์', type: 'submittable' },
    { key: 'post-targets', label: 'ปลายทางการโพสต์' },
    { key: 'media-assets', label: 'สื่อ' },
    { key: 'publish-logs', label: 'บันทึกการเผยแพร่' },
    { key: 'post-insights', label: 'ข้อมูลเชิงลึก' },
  ],
  availableHooks: [
    { event: 'marketing.post.approved', label: 'อนุมัติโพสต์' },
    { event: 'marketing.post.scheduled', label: 'ตั้งเวลาโพสต์' },
    { event: 'marketing.post.published', label: 'เผยแพร่โพสต์สำเร็จ' },
    { event: 'marketing.post.failed', label: 'เผยแพร่โพสต์ล้มเหลว' },
    { event: 'marketing.post.cancelled', label: 'ยกเลิกการเผยแพร่' },
  ],

  extendSchemas: {},
  fixtures: [],

  moduleMigrations: migrations,

  // Doctype Catalog (#644 / #786) — metadata-rich registry rows consumed by
  // the tenant-worker boot loop. Marketing routes/services own writes; this
  // surface is for the Admin UI + custom-field + permission machinery.
  registeredDoctypes: marketingDoctypes,
})
